import { render, staticRenderFns } from "./AddServicePlate.vue?vue&type=template&id=6bc8d770&scoped=true&"
import script from "./AddServicePlate.vue?vue&type=script&lang=js&"
export * from "./AddServicePlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8d770",
  null
  
)

export default component.exports